import $ from 'jquery';
import DDTemplates from 'dd-templates';
import Drupal from './Drupal';
import Header from './Header';
import Menu from './Menu';
import Footer from './Footer';
import TermNavigation from './TermNavigation';
import Toolbar from './Toolbar';
import Gallery from './Gallery';
import CalendarFeed from './CalendarFeed';
import Hero from './Hero';
import FeaturedCarousel from './FeaturedCarousel';
import NewsCarousel from './NewsCarousel';
import Dropdown from './Dropdown';

/**
 * THEME SPECIFIC BEHAVIORS
 * @param {*} context
 */

function themeSpecificBehaviors(context) {
  // Add backgrounds to the featured posts of the homepage block and converts them
  // into a slick carousel instance.
  $('#block-views_blocks-term-block_1-5', context).each((a, element) => {
    if (!element.featuredCarousel) {
      element.featuredCarousel = new FeaturedCarousel(element);
    }
  });

  // Add backgrounds to the featured posts of the homepage block and converts them
  // into a slick carousel instance.
  $('#block-views_blocks-term-block_1-6', context).each((b, element) => {
    if (!element.newsCarousel) {
      element.newsCarousel = new NewsCarousel(element);
    }
  });

  // Controls the page overlay display
  $('.page-header', context).bind('click', (event) => {
    if ($(event.target).is('.page-header')) {
      $(document.body).removeClass('menu-active search-active');
      $(event.target).scrollTop(0);
    }
  });

  // Gives all pod webform textfields placeholder text
  $('.pods .node-webform', context).each((i, element) => {
    $('.form-item.type-textfield', element).each((c, field) => {
      const txt = $(field).find('label').text().replace(':', '');
      if (txt.length) {
        $(field).find('input').attr('placeholder', txt);
      }
    });
  });

  // Manage node content within a hero post
  $('#block-views_blocks-term-block_1-1', context).each((d, element) => {
    if (!element.hero) {
      element.hero = new Hero(element);
    }
  });

  // Add dropdown functionality to the industries block
  $('#block-views_blocks-term-block_1-9', context).each((e, element) => {
    if (!element.dropdown) {
      element.dropdown = new Dropdown(element);
    }
  });
}

/**
 * DEFAULT THEME BEHAVIORS
 * @param {*} context
 */

function defaultBehaviors(context) {
  // DD Template Behaviors

  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Fix our damn menus from displaying orphaned children

  $('.primary-navigation, .term-nav', context).each((a, element) => {
    $('.menuparent, .expanded, .collapsed', element).each((b, item) => {
      // handles the parent term (if hidden)
      const $parent = $(item).children('a');
      if (!$parent.length || $parent.is('.hidden')) {
        $(item).remove();
      }
      // handles the term to see if it only parents orphans.
      const $children = $('> ul > li', item);
      if (!$parent.is('.hidden') && $children.length) {
        const $orphans = $children.children('a.hidden');
        $orphans.parent().remove();
        if ($orphans.length === $children.length) {
          $(item).removeClass('expanded menuparent collapsed');
          $(item).children('ul').remove();
        }
      }
    });
  });

  // Main/Primary Site Navigation

  $('#block-nice_menus-3', context).each((c, element) => {
    if (!element.menu) {
      element.menu = new Menu(element, { breakpoint: 1024 });
    }
  });

  // Fixed Header using Headroom.js

  $('.headroom', context).each((d, element) => {
    if (!element.headroom) {
      element.headroom = new Header(element);
    }
  });

  // Controls the states of the menu and search displays

  $('.site-toolbar', context).each((e, element) => {
    if (!element.toolbar) {
      element.toolbar = new Toolbar(element, context);
    }
  });

  // Smart Footer

  $('.page-footer', context).each((f, footer) => {
    const $footprint = $('.footprint', context);
    if (!footer.smartFooter && $footprint.length) {
      footer.smartFooter = new Footer(footer, $footprint);
    }
  });

  // Term Navigation

  $('.term-nav', context).each((g, element) => {
    if (!element.termNavigation) {
      element.termNavigation = new TermNavigation(element);
    }
  });

  // Photo Galleries

  const galleries = '.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image';
  $(galleries, context).each((h, element) => {
    if (!element.gallery) {
      element.gallery = new Gallery(element);
    }
  });

  // Calendar of Events View

  $('.calendar-feed', context).each((i, element) => {
    if (!element.calendarFeed) {
      element.calendarFeed = new CalendarFeed(element);
    }
  });

  // Add Sitemap output using the digitaldcore.js function

  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }
}

// Add the behaviors into the queue
Drupal.behavior((context) => {
  defaultBehaviors(context);
  themeSpecificBehaviors(context);
});



// WEBPACK FOOTER //
// ./theme.js